var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01128 5.47179C4.89718 5.47179 5.61534 4.75363 5.61534 3.86773C5.61534 2.98183 4.89718 2.26367 4.01128 2.26367C3.12539 2.26367 2.40723 2.98183 2.40723 3.86773C2.40723 4.75363 3.12539 5.47179 4.01128 5.47179Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12999 6.68722V15.5865H9.89311V11.1856C9.89311 10.0244 10.1116 8.89976 11.5514 8.89976C12.9715 8.89976 12.9891 10.2274 12.9891 11.2589V15.5872H15.7536V10.7069C15.7536 8.30961 15.2375 6.46729 12.4356 6.46729C11.0903 6.46729 10.1886 7.20553 9.8198 7.90419H9.78241V6.68722H7.12999ZM2.6272 6.68722H5.39471V15.5865H2.6272V6.68722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.96bb9c1f60cc5e9cd0602353908df697.svg";
export { ForwardRef as ReactComponent };